export default "__VITE_ASSET__5XvYlx1J__"